export default {
    baseStyle: {
        container: {
            borderRadius: '10px',
            border: '1px solid',
            borderColor: 'warm.400',
            bg: 'gray.100',
            textAlign: 'center',
            padding: '30px'
        },
        inner: {
            maxWidth: '100%',
            margin: '0 auto'
        },
        header: {
            fontFamily: 'cormorant',
            fontWeight: '400',
            color: 'black.100',
            fontSize: '30px',
            lineHeight: 'normal',
            marginBottom: '20px'
        },
        connectText: {
            fontSize: '14px',
            fontWeight: 300,
            lineHeight: '22px',
            letterSpacing: '0.07px',
            color: 'purple.600',
            marginBottom: '15px'
        },
        ctaLink: {
            fontSize: '17px',
            fontFamily: 'body',
            fontWeight: '400',
            lineHeight: '26px',
            letterSpacing: '0.085px',
            color: 'white',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '90px',
            bg: 'purple.600',
            width: '100%',
            maxWidth: '326px',
            margin: '0 auto',
            padding: '15px',
            marginBottom: '20px',
            textDecoration: 'none',
            _hover: {
                bg: 'purple.300',
                color: 'white',
                textDecoration: 'none'
            },
            _focus: {
                bg: 'purple.300',
                color: 'white'
            }
        },
        ctaImage: {
            marginRight: '10px'
        },
        disclaimer: {
            fontSize: '13px',
            fontWeight: 300,
            lineHeight: '18px',
            color: 'black.300',
            marginBottom: '15px'
        }
    }
}
